import { Injector } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { BaseService } from '../../lib-shared/services/base.service';
import { catchError } from 'rxjs/operators';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
export class WardsService extends BaseService {
    constructor(http, injector) {
        super(http, injector, `${environment.apiDomain.dapFoodEndPoint}/Wards`);
    }
    Save(item) {
        return this._http
            .post(this.serviceUri, item)
            .pipe(catchError(err => this.handleError(err, this._injector))).toPromise();
    }
    Gets(key, idWard, idDistrict, offset, limit, sortField, isAsc = false) {
        const queryString = `${this.serviceUri}?key=${key}&idWard=${idWard}&idDistrict=${idDistrict}&offset=${offset}&limit=${limit}&sortField=${sortField}&isAsc=${isAsc}`;
        return this.defaultGet(queryString);
    }
    GetShort(idDistrict) {
        const queryString = `${this.serviceUri}/GetShort?idDistrict=${idDistrict}`;
        return this.defaultGet(queryString);
    }
    GetShortByListId(lstId) {
        const queryString = `${this.serviceUri}/GetShortByListId?listId=${lstId}`;
        return this.defaultGet(queryString);
    }
    ChangeDeleted(item) {
        return this._http
            .post(this.serviceUri + '/ChangeDeleted/' + item.id, item)
            .pipe(catchError(err => this.handleError(err, this._injector))).toPromise();
    }
}
WardsService.ngInjectableDef = i0.defineInjectable({ factory: function WardsService_Factory() { return new WardsService(i0.inject(i1.HttpClient), i0.inject(i0.INJECTOR)); }, token: WardsService, providedIn: "root" });
